// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VNv_0Mdu4BYcdq {
  height: 292px;
  margin-bottom: 8px;
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: h4tjYyXjdKDUOq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes h4tjYyXjdKDUOq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .VNv_0Mdu4BYcdq {
    animation: none;
  }
}
.ATmQWRWxA8tdqs {
  height: 52px;
  margin-bottom: 12px;
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: h4tjYyXjdKDUOq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes h4tjYyXjdKDUOq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ATmQWRWxA8tdqs {
    animation: none;
  }
}
.b6KsuSqpsj4Aki {
  height: 54px;
  margin-top: 24px;
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: h4tjYyXjdKDUOq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes h4tjYyXjdKDUOq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .b6KsuSqpsj4Aki {
    animation: none;
  }
}
.vJBXY1USNLUw3I {
  height: 40px;
  margin-top: 8px;
  margin-bottom: 12px;
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: h4tjYyXjdKDUOq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes h4tjYyXjdKDUOq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .vJBXY1USNLUw3I {
    animation: none;
  }
}
.sj0c89LnzbnSUJ {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.vvzmhWjc400uK4 {
  height: 32px;
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: h4tjYyXjdKDUOq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes h4tjYyXjdKDUOq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .vvzmhWjc400uK4 {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendar": `VNv_0Mdu4BYcdq`,
	"shimmer": `h4tjYyXjdKDUOq`,
	"dateField": `ATmQWRWxA8tdqs`,
	"dueReminderField": `b6KsuSqpsj4Aki`,
	"dueReminderClarification": `vJBXY1USNLUw3I`,
	"buttons": `sj0c89LnzbnSUJ`,
	"button": `vvzmhWjc400uK4`
};
export default ___CSS_LOADER_EXPORT___;
